import React from 'react';
export function SuccessInsert() {
  return <section className="relative w-full overflow-hidden" data-id="element-239">
      {/* Full-width image */}
      <div className="relative w-full aspect-[4/3] md:aspect-[16/9]" data-id="element-240">
        <img src="https://cdn.magicpatterns.com/uploads/9ssQ31DPucgnDVXtaQyh5u/imagen_landing1.png" alt="Perro relajado en terraza" className="w-full h-full object-cover" data-id="element-241" />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/60 to-charcoal/30" data-id="element-242"></div>

        {/* Text overlay */}
        <div className="absolute inset-0 flex items-end pb-10 md:pb-16 px-6" data-id="element-243">
          <div className="max-w-lg mx-auto w-full text-center" data-id="element-244">
            <p className="text-xl md:text-2xl font-bold text-white leading-snug tracking-tight" data-id="element-245">
              De la guerra diaria a disfrutar de cada mañana.
            </p>
            <p className="text-xl md:text-2xl font-bold text-teal leading-snug tracking-tight mt-1" data-id="element-246">
              Es posible.
            </p>
          </div>
        </div>
      </div>
    </section>;
}